import React, { useState, useEffect, useRef } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import { updateFocusedCell, startColumnResize } from './helpers'
import Header from './Header/header';
import BodyIndex from './BodyIndex';
// import isEqual from 'lodash.isequal';

let skipGlobalClick = false;
let mouseDownInTable = false;

const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}


// const propsAreEqual = (prev, next) => {
//     return isEqual(prev.rows, next.rows)
//     && isEqual(prev.columns, next.columns)
// }

const DataTable = (props) => {
    const [columnWidthList, setColumnWidthList] = useState(null);
    const [tableHeight, setTableHeight] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ coords: { x: 0, y: 0 }, active: false });
    const lastRowRef = useRef(0);
    const ignoreLeaveRowRef = useRef(false);

    const { version, rowsVersion, rows, columns, columnWidthValues, columnMinWidthValues, columnMaxWidthValues, onColumnResize, moveCell, selectCell
        , getRowKey, disabledCellChecker, focusedCellChange, onLeaveRow, noLazy, placeholderOnScroll } = props;

    const prevProps = usePrevious({ version, rows });

    // const rowDiff = prevProps ? props.rows.length - prevProps.rows.length : 0;

    let primaryColumnWidthValues = columnWidthValues;

    const updateColumnWidthList = (newColumnWidth) => {
        setColumnWidthList(newColumnWidth);
    };

    const onFocusedCell = ({ x, y, active, ignoreLeaveRow }) => {
        if (y < 0)
            y = 0;
        else if (y >= columns.length)
            y = columns.length - 1;
        if (x < 0)
            x = 0;
        else if (x >= rows.length)
            x = rows.length - 1;
        if (lastRowRef.current !== x && !ignoreLeaveRow) {
            onLeaveRow({ x, y });
        }
        setFocusedCell({ coords: { x, y }, active });
        lastRowRef.current = x;
        ignoreLeaveRowRef.current = ignoreLeaveRow;
        focusedCellHandler({ coords: { x, y }, active });
    }

    const focusedCellHandler = ({ coords: { x, y }, active }) => {
        const row = rows[x];
        const column = columns[y];
        const key = props.getRowKey(row);
        focusedCellChange({ x, y, row, column, active, key });
    }

    const setCellDirectly = (x, y, active, isFocused, isActive, disabled) => {
        if (!isFocused)
            onFocusedCell({ x, y, active });
        skipGlobalClick = true;
    }

    const startColumnResizeHanlder = (e, column) => {
        startColumnResize(e, column, columns, columnWidthList, primaryColumnWidthValues, columnMinWidthValues, columnMaxWidthValues, updateColumnWidthList, onColumnResize)
    }



    const isEventInTable = (e) => {
        const table = document.getElementById(`DataTable`);
        if (!table) return false;
        const path = e.path || (e.composedPath && e.composedPath());
        return path ? path.includes(table) : table.contains(e.target);
    }

    const onGlobalMouseDown = (e) => {
        mouseDownInTable = isEventInTable(e);
    }

    const onGlobalClick = (e) => {
        // when the select menu closes mid-click the browser retargets the click
        // to a common ancestor outside the table, so also trust where the
        // gesture started (RWR-18079)
        const isInTable = isEventInTable(e) || mouseDownInTable;
        mouseDownInTable = false;
        if (!skipGlobalClick && !isInTable) {
            onFocusedCell({ x: null, y: null });
        } else {
            skipGlobalClick = false;
        }
    }

    // useEffect(() => {
    //     setFocusedCell(focusedCell);
    // });

    useEffect(() => {
        if (selectCell.key && (focusedCell.coords.x !== selectCell.x || focusedCell.coords.y !== selectCell.y || focusedCell.active !== selectCell.active)) {
            onFocusedCell({ x: selectCell.x, y: selectCell.y, active: selectCell.active });
        }
    }, [selectCell]);

    useEffect(() => {
        const updateTableHeight = () => {
            const dataTableHeight = document.getElementById('DataTable').offsetHeight;
            const headerHeight = document.getElementById('header-row').offsetHeight;
            setTableHeight(dataTableHeight - headerHeight);
        }

        function handleResizeWindow() {
            updateTableHeight();
            updateColumnWidthList(null);
        }

        window.addEventListener('resize', handleResizeWindow);
        document.addEventListener('mousedown', onGlobalMouseDown);
        document.addEventListener('click', onGlobalClick);

        if (!tableHeight) {
            focusedCellHandler(focusedCell);
            updateTableHeight();
        }
        return () => {
            window.removeEventListener('resize', handleResizeWindow);
            document.removeEventListener('mousedown', onGlobalMouseDown);
            document.removeEventListener('click', onGlobalClick);
        }
    }, []);

    useEffect(() => {
        if (moveCell) {
            updateFocusedCell(moveCell, columns, rows, focusedCell, onFocusedCell, disabledCellChecker)
            skipGlobalClick = true;
        }
    }, [moveCell]);

    // useEffect(() => {
    //     if (rowDiff < 0) {
    //         const { coords, active } = focusedCell;
    //         setFocusedCell({ coords: { x: (coords.x + rowDiff > 0) ? coords.x + rowDiff : 0, y: coords.y }, active });
    //         // move the focused cell when table is filtered
    //     }
    // }, [rowDiff])

    useEffect(() => {
        if (prevProps && prevProps.version !== version)
            updateColumnWidthList(null);
    }, [version])

    useEffect(() => {
        if (Number.isInteger(focusedCell.coords.x))
          if (!ignoreLeaveRowRef.current) focusedCellHandler({ coords: { x: focusedCell.coords.x, y: focusedCell.coords.y }, active: focusedCell.active });
    }, [rows])

    const type = noLazy ? 'body-nolazy' : 'body-lazy';
    const Body = BodyIndex[type];

    return (
        <TableContainer>
            <Header columnWidthList={columnWidthList} columns={columns} primaryColumnWidthValues={primaryColumnWidthValues} updateColumnWidthList={updateColumnWidthList} startColumnResize={startColumnResizeHanlder} version={version}></Header>
            {columnWidthList && tableHeight && <Body columnWidthList={columnWidthList} rowsVersion={rowsVersion} columns={columns} rows={rows} getRowKey={getRowKey} height={tableHeight} rowheight={65} focusedCell={focusedCell} setCellDirectly={setCellDirectly}
                disabledCellChecker={disabledCellChecker} contextMenuId={props.contextMenuId} placeholderOnScroll={placeholderOnScroll}></Body>}
        </TableContainer>
    )
}

// export default React.memo(DataTable, propsAreEqual);
export default DataTable;


// WEBPACK FOOTER //
// ./src/components/DataTable/table.js